import { Link, useLocation } from "react-router-dom";
import { LogOut, ShieldCheck, Users } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../lib/auth";
import NotificationBell from "./NotificationBell";
import Footer from "./Footer";

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const onAdmin = loc.pathname.startsWith("/admin");
  const onSup = loc.pathname.startsWith("/supervisor");

  return (
    <div className="min-h-screen flex flex-col bg-[#0A0A0A] text-[#F5F5F5]">
      <header className="sticky top-0 z-30 bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-[#2A2A2A]">
        <div className="max-w-[1400px] mx-auto px-3 sm:px-6 h-16 sm:h-20 flex items-center justify-between gap-2">
          <Link to="/" className="flex items-center gap-3 min-w-0" data-testid="nav-home-link">
            <img src="/pnc-logo-white.png" alt="PNC UNIQUE" className="h-10 sm:h-12 w-auto shrink-0"/>
            <div className="hidden sm:block leading-tight min-w-0 border-l border-[#2A2A2A] pl-3">
              <div className="text-[11px] uppercase tracking-[0.18em] text-[#C0C0C0] font-semibold">Absence</div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-[#A8A8A8] font-medium">Notifications</div>
            </div>
          </Link>
          <nav className="flex items-center gap-1 sm:gap-2 shrink-0">
            {user && (
              <>
                {user.is_admin && (
                  <Link to="/admin">
                    <Button
                      data-testid="nav-admin-btn"
                      variant={onAdmin ? "default" : "ghost"}
                      size="sm"
                      className="gap-1.5 px-2 sm:px-3"
                    >
                      <ShieldCheck className="w-4 h-4" strokeWidth={2}/>
                      <span className="hidden sm:inline">Admin</span>
                    </Button>
                  </Link>
                )}
                <Link to="/supervisor">
                  <Button
                    data-testid="nav-supervisor-btn"
                    variant={onSup ? "default" : "ghost"}
                    size="sm"
                    className="gap-1.5 px-2 sm:px-3"
                  >
                    <Users className="w-4 h-4" strokeWidth={2}/>
                    <span className="hidden sm:inline">Supervisor</span>
                  </Button>
                </Link>
                <NotificationBell isAdmin={!!user.is_admin}/>
                <div className="hidden md:block text-sm text-[#A8A8A8] ml-1 mr-1 max-w-[140px] truncate">
                  {user.name}
                </div>
                <Button data-testid="logout-btn" variant="outline" size="sm" onClick={logout} className="gap-1.5 px-2 sm:px-3">
                  <LogOut className="w-4 h-4" strokeWidth={2}/>
                  <span className="hidden sm:inline">Sign out</span>
                </Button>
              </>
            )}
            {!user && (
              <>
                <Link to="/request">
                  <Button data-testid="nav-request-btn" variant="ghost" size="sm">Submit a notification</Button>
                </Link>
                <Link to="/login">
                  <Button data-testid="nav-login-btn" size="sm">Staff sign in</Button>
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className="flex-1 min-w-0 overflow-x-hidden">{children}</main>
      <Footer/>
    </div>
  );
}
